import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  template: {}
  question1: {}
  question2: {}
  nextButton: {}
}>('headless-two-radio-inputs')
